import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
  selector: 'cq-image-preview',
  templateUrl: './cq-image-preview.component.html',
  styleUrls: ['./cq-image-preview.component.scss']
})
export class CqImagePreviewComponent implements OnInit {

  file: File
  @Input('file') set _file( file: File){
    this.file = file
    this.updatePreview()
  }

  src: string
  @Input('src') set _src( src: string){
    this.src = src
    this.imgURL = src
  }
  imgURL: any

  constructor(
    private domSanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

  }

  updatePreview(){
    if( !this.file ) return 

    var reader = new FileReader();
    reader.readAsDataURL(this.file); 
    
    reader.onload = (_event) => {       
      this.imgURL =  reader.result
    }
  }
}
